import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, Typography, IconButton, Popover } from '@mui/material';
import { useToast } from '../../../providers/ToastProvider';
// components
import Iconify from '../../../components/iconify';
//
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import api from '../../../config/axios-instance';
import { ENV } from '../../../config/config';
import { useApiTrigger } from '../../../providers/apiTriggerContext';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
    position: 'absolute',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${NAV_WIDTH + 1}px)`,
    },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('xs')]: {
        minHeight: HEADER_MOBILE,
        padding: theme.spacing(1, 3),
    },
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        padding: theme.spacing(1.4, 8),
    },
}));

const StatsTypography = styled(Typography)(({ theme }) => ({
    '&.MuiTypography-subtitle1': {
      color: '#7b7b7b',
      fontSize: '14px',
      fontWeight: '400',
      textAlign: 'center',
      lineHeight: '16px',
      marginTop: '12px',
      marginBottom: '5px',
    },
    '&.MuiTypography-h4': {
      fontSize: '20px',
      fontWeight: "bold",
    }

  }));

// ----------------------------------------------------------------------

Header.propTypes = {
    onOpenNav: PropTypes.func,
};

export default function Header({ toggleNav }) {

    const [open, setOpen] = useState(null);
    const token = JSON.parse(localStorage.getItem('clientToken'));
    const { shouldTrigger, resetTrigger } = useApiTrigger();
    const hasCalledOnce = useRef(false);
    console.log("shouldTrigger", shouldTrigger);
    const toast = useToast();
    const [stats, setStats] = useState("");

    const handleOpen = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClose = () => {
        setOpen(null);
    };
    
    useEffect(() => {
        const fetchTeacherProfile = async () => {
            const url = `${ENV.appBaseUrl}/teacher/profile`;
            try {
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                };
                const response = await api.get(url, config);

                setStats(response?.data?.teacher?.school?.plan);
            } catch (error) {
                toast.error(error?.response?.data?.message);
            }
        };

        if (!hasCalledOnce.current || shouldTrigger) {
            fetchTeacherProfile();
            resetTrigger();
        }
    }, [shouldTrigger]);
    
    console.log("stats===", stats);
    console.log("stats.name");
    const statsData = [
        { 
            title: "Plan", 
            value: (!stats?.name && stats?.features?.teacher == 1) ? "Trail" : (stats?.name || ""),
            icon: "/assets/icons/quota.png",
            customColor: "blue-txt",
        },
        { 
            title: "Teacher", 
            value: stats?.features?.teacher,
            icon: "/assets/icons/ic_user.svg",
            customColor: "orange-txt"
        },
        { 
            title: "Documents", 
            value: stats?.features?.pageAnalyze,
            icon: "/assets/icons/document.png",
            customColor: "green-txt"
        },
        ];
        
    return (
        <StyledRoot>
            <StyledToolbar>
                <IconButton
                    onClick={toggleNav}
                    className="menu-bar-icon"
                    sx={{
                        mr: 1,
                        color: 'text.primary',
                        display: { lg: 'none' },
                    }}
                >
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
                <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: 'flex', gap: 2, flex: 'auto', justifyContent: 'flex-end', mr: 2 }} className="desktop-stats">
                        {statsData.map((stat, index) => (
                        <Box 
                            key={index}
                            className='stat-bx'
                            sx={{ 
                                p: 1,
                                border: '1px solid',
                                background: '#e3f6f3',
                                borderColor: 'rgb(52 165 149 / 31%)',
                                borderRadius: 2,
                                minWidth: 180,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                            >
                            <img 
                                src={stat?.icon} 
                                alt={stat.title} 
                                width={22} 
                            />
                            <StatsTypography variant="subtitle1">
                                {stat.title}
                            </StatsTypography>
                            <StatsTypography variant="h4" className={stat?.customColor}>
                                {stat.value}
                            </StatsTypography>
                        </Box>
                        ))}
                    </Box>
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={{
                            xs: 0.5,
                            sm: 1,
                        }}
                    >
                        {/* {!isTeachersPage && <Searchbar />} */}
                        {/* {isSuperAdmin("Super Admin")? <NotificationsPopover /> : null} */}
                        <Box className="mobile-stats">
                            <IconButton onClick={handleOpen} sx={{p: 1.2,border: '1px solid #34A595'}}>
                                <img 
                                    src="/assets/icons/document.png"
                                    alt="document" 
                                    width={20} 
                                    height={20} 
                                />
                            </IconButton>
                            <Popover
                                open={Boolean(open)}
                                anchorEl={open}
                                onClose={handleClose}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{
                                    sx: {
                                        p: 0,
                                        mt: 1.5,
                                        ml: 0.75,
                                        width: 200,
                                        background: 'transparent',
                                        boxShadow: 'none',
                                        '& .MuiMenuItem-root': {
                                            typography: 'body2',
                                            borderRadius: 0.75,
                                        },
                                    },
                                }}
                            >
                                <Box className="stat-bx-wrap">
                                    {statsData.map((stat, index) => (
                                    <Box 
                                        key={index}
                                        className='stat-bx'
                                        sx={{ 
                                            p: 1,
                                            border: '1px solid',
                                            background: '#e3f6f3',
                                            borderColor: 'rgb(52 165 149 / 31%)',
                                            borderRadius: 2,
                                            minWidth: 180,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                        >
                                        <Box className="ico">
                                            <img 
                                                src={stat?.icon} 
                                                alt={stat.title} 
                                                width={22} 
                                            />
                                        </Box>
                                        <Box>
                                            <StatsTypography variant="subtitle1">
                                            {stat.title}
                                            </StatsTypography>
                                            <StatsTypography variant="h4" className={stat?.customColor}>
                                                {stat.value}
                                            </StatsTypography>
                                        </Box>
                                    </Box>
                                    ))}
                                </Box>                          
                            </Popover>
                        </Box>    
                        <NotificationsPopover />
                        <AccountPopover />
                    </Stack> 
            </StyledToolbar>
        </StyledRoot>
    );
}
